<template>
  <el-form-item
    v-if="$attrs['prop']"
    class="unset"
    :label-width="$attrs['label-width']"
    :prop="$attrs['prop']"
    :label="$attrs['label']"
    :class="[!labelShow ? 'lable-hidden' : '']"
  >
    <el-date-picker
      :id="$attrs['prop']"
      ref="datepicker"
      v-model.trim="innerValue"
      v-bind="{ ...$attrs }"
      :class="['date-picker-icon', iconTemp ? 'date-close' : '']"
      :picker-options="pickerOptions"
      :default-value="defaultValue"
      :disabled="disabled"
      autocomplete="off"
      @mouseenter.native="setDateIcon"
      @mouseleave.native="iconTemp = false"
      @change="(value) => timeChange(value)"
      @blur="(value) => handleBlur(value)"
    />
    <template #error="{ error }">
      <el-tooltip class="item" effect="dark" :content="error" placement="left">
        <div
          class="el-form-item__error"
          :class="{ error_box: $attrs['error'] == 'true' }"
        >
          {{ error }}
        </div>
      </el-tooltip>
    </template>
  </el-form-item>
  <el-form-item
    v-else
    :label-width="$attrs['label-width']"
    :label="$attrs['label']"
    :class="[!labelShow ? 'lable-hidden' : '', disabled ? 'mb-none' : '']"
  >
    <el-date-picker
      ref="datepicker"
      :value="$attrs['value']"
      v-bind="{ ...$attrs }"
      :class="['date-picker-icon', iconTemp ? 'date-close' : '']"
      :picker-options="pickerOptions"
      :disabled="disabled"
      autocomplete="off"
      @mouseenter.native="setDateIcon"
      @mouseleave.native="iconTemp = false"
    />
  </el-form-item>
</template>

<script>
  import mixins from '@/utils/mixForm'
  export default {
    name: 'VabDatePicker',
    componentName: 'VabDatePicker',
    mixins: [mixins],
    data() {
      let that = this
      return {
        iconTemp: false,
        pickerOptions: {
          disabledDate(time) {
            if (that.workYmDate) {
              let workYm = that.$dayjs(that.workYmDate).format('YYYY/MM')
              let startTime = workYm + '/01'
              let day = that.$dayjs(`${startTime}`).daysInMonth()
              let endTime = workYm + '/' + day
              let dayTemp2 = false
              let dayTemp3 = false
              let dayTemp1 =
                that.$dayjs(time).isBefore(startTime) ||
                that.$dayjs(time).isAfter(endTime)
              if (that.endDateProp) {
                let endDate = that.$baseLodash.get(
                  that.form.model,
                  that.endDateProp
                )
                if (!that.$baseLodash.isEmpty(endDate)) {
                  dayTemp2 = that.$dayjs(time).isSameOrAfter(endDate)
                }
              }
              if (that.startDateProp) {
                let startDate = that.$baseLodash.get(
                  that.form.model,
                  that.startDateProp
                )
                if (!that.$baseLodash.isEmpty(startDate)) {
                  dayTemp3 = that.$dayjs(time).isSameOrBefore(startDate)
                }
              }
              return dayTemp1 || dayTemp2 || dayTemp3
            }

            if (that.startDateProp) {
              let startDate = that.unForm
                ? that.startDateProp
                : that.$baseLodash.get(that.form.model, that.startDateProp)

              if (!that.$baseLodash.isEmpty(startDate)) {
                if (that.enableSameDate) {
                  return that.$dayjs(time).isBefore(startDate)
                } else {
                  return that.$dayjs(time).isSameOrBefore(startDate)
                }
              }
            }

            if (that.endDateProp) {
              let endDate = that.$baseLodash.get(
                that.form.model,
                that.endDateProp
              )
              if (!that.$baseLodash.isEmpty(endDate)) {
                if (that.enableSameDate) {
                  return that.$dayjs(time).isAfter(endDate)
                } else {
                  return that.$dayjs(time).isSameOrAfter(endDate)
                }
              }
            }
          },
        },
      }
    },
    created() {
      // this.type = 'date'
    },
    methods: {
      timeChange(val) {
        this.setModel(val)
      },
      setDateIcon() {
        if (this.innerValue == '' || this.innerValue == null || this.disabled) {
          this.iconTemp = false
        } else {
          this.iconTemp = true
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .lable-hidden {
    ::v-deep {
      .el-form-item__label {
        display: none;
        width: 0px !important;
      }
      .el-form-item__content {
        margin-left: 0px !important;
      }
    }
  }
  .date-picker-icon {
    width: 100%;
    &.date-close {
      ::v-deep {
        .el-input__prefix {
          display: none !important;
        }
      }
      .el-icon-date {
        display: none;
      }
    }
    ::v-deep {
      .el-input__inner {
        padding-right: 25px !important;
        padding-left: 5px !important;
      }

      .el-input__prefix {
        right: 5px;
        left: initial;
      }
    }
  }
</style>
<style lang="scss" scoped>
  @import '@/vab/styles/component.scss';
</style>
